export default __webpack_public_path__ + "static/media/SourceSansPro-Italic.80e3f9de.eot";